module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content login-wrapper"
  }, [_c('div', {
    staticClass: "content-inner loginBox"
  }, [_c('div', {
    staticClass: "flex-column full-w centered"
  }, [_c('div', {
    staticClass: "min-width-300 max-width-300"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/kundan-logo.png"),
      "width": "200px"
    }
  }), _vm._v(" "), (this.step == 1) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.headerMessage1))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.headerMessage2))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "save": _vm.next,
      "form": _vm.form,
      "btn-text": "button.next",
      "translation": "form.register"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.step == 2) ? _c('div', [_c('h3', [_vm._v("Du er nesten ferdig...")]), _vm._v(" "), _c('v-form', {
    attrs: {
      "save": _vm.register,
      "form": _vm.finalStep,
      "btn-text": "button.getStarted",
      "translation": "form.register"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loginInstead) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.emailSetup.emailExistSuggestion')))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "forgot-password"
  }, [_c('router-link', {
    staticClass: "buttons_login",
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.login')))])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56906da3","hasScoped":false}!./src/app/pages/register/emailSetup/emailSetup.html
// module id = 3016
// module chunks = 1